export default {"src":"/_next/static/media/wave-mobile.af036cd1.svg","height":86,"width":375,"blurWidth":0,"blurHeight":0};